export default __webpack_public_path__ + "static/media/infiniteLogo.9f9fb1ec.svg";